import { Component, Input } from '@angular/core';
import type { IFAQLibrary } from '../../../../../../../../../shared/src/faqs/faqs.interface';

@Component({
  standalone: false,
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss',
})
export class FaqsComponent {
  @Input() faqLibrary?: IFAQLibrary;
}
